import AboutUs from '../components/AboutUs'

const About = () => {
  return (
    <div className="pt-10">
      <AboutUs />
    </div>
  )
}
export default About
